module.exports = __webpack_public_path__ + "img/13.75f325e6.png";